import fetch from '../config/fetch'
import { Loading } from 'element-ui';
import * as config from '../config/const';

export const ADMIN_JSON='/adminjson';

export const userinfo = () => fetch(ADMIN_JSON+'/userinfo.json');
export const logout = () => fetch(ADMIN_JSON+'/logout.json');
export const lgabh = (param) => fetch(ADMIN_JSON+'/lgabh.json',param);
export const getUnreadData = (param) => fetch(ADMIN_JSON+'/getUnreadData.json',param);

export const findCronTask = (param) => fetch(ADMIN_JSON+'/findCronTask.json',param);
export const modifyLogType = param =>
  fetch(ADMIN_JSON + "/modifyLogType.json", param);
export const findCronTaskRecord = (param) => fetch(ADMIN_JSON+'/findCronTaskRecord.json',param);
export const addCronTask = (param) => fetch(ADMIN_JSON+'/addCronTask.json',param,'POST');
export const modifyCronTask = (param) => fetch(ADMIN_JSON+'/modifyCronTask.json',param,'POST');
export const switchStatus = (param) => fetch(ADMIN_JSON+'/switchStatus.json',param);
export const setSwitchStatus = (param) => fetch(ADMIN_JSON+'/setSwitchStatus.json',param);
export const findOneCron = (param) => fetch(ADMIN_JSON+'/findOneCron.json',param);
export const modifyStatus = (param) => fetch(ADMIN_JSON+'/modifyStatus.json',param);
export const initCronTask = (param) => fetch(ADMIN_JSON+'/initCronTask.json',param);
export const executeOneTask = (param) => fetch(ADMIN_JSON+'/executeOneTask.json',param);
export const delOneTask = (param) => fetch(ADMIN_JSON+'/delOneTask.json',param);
//面板接口
export const addDataModel = (param) => fetch(ADMIN_JSON+'/addDataModel.json',param,'POST');
export const deleteDataModel = (param) => fetch(ADMIN_JSON+'/deleteDataModel.json',param);
export const modelInfo = (param) => fetch(ADMIN_JSON+'/modelInfo.json',param);
export const modDataModel = (param) => fetch(ADMIN_JSON+'/modDataModel.json',param,'POST');
export const modelList = (param) => fetch(ADMIN_JSON+'/modelList.json',param);

//面板的接口
export const dataPanelList = (param) => fetch(ADMIN_JSON+'/dataPanelList.json',param);
export const addModelPanel = (param) => fetch(ADMIN_JSON+'/addModelPanel.json',param);
export const deleteModelPanel = (param) => fetch(ADMIN_JSON+'/deleteModelPanel.json',param);
export const modModelPanel = (param) => fetch(ADMIN_JSON+'/modModelPanel.json',param);
//查询数据
export const Panels = (param) => fetch(ADMIN_JSON+'/panels.json',param);
export const Paneldata = (param) => fetch(ADMIN_JSON+'/panelData.json',param);
//查询面板历史所有数据
export const models = (param) => fetch(ADMIN_JSON+'/models.json',param);
export const modelData = (param) => fetch(ADMIN_JSON+'/modelData.json',param);
export const modelStocks = (param) => fetch(ADMIN_JSON+'/modelStocks.json',param);
export const addDataStock = (param) => fetch(ADMIN_JSON+'/addDataStock.json',param,'POST');


export const ajax = {
  data(){
    return {
      loadingTool:'',
      _imdoing:''
    }
  },
  methods: {
    async doajax(method,param,success,err){
      if (this._imdoing==method) {
        return;
      }
      this._imdoing=method;
      this.openLoading();
      this.ajax(await method(param),success,err);
      this.closeLoading();
      this._imdoing='';
    },
    ajax(res, success,err){
      if(res.success){
        success.call(this, res)
      }else{
        if (err !== undefined) {
          err.call(this, res);
        } else if (res.auth !== undefined) {
          var filter = config.AUTH_FILTER.admin;
          this.removeUser();
          top.location.href=filter.loginUrl;
        } else if (res.permission !== undefined) {
          this.refreshUser();
        } else {
          this.error(res.msg);
        }
      }

    },
    openLoading(){
      this.loadingTool=Loading.service({ fullscreen: true });
    },
    closeLoading(){
      this.loadingTool.close();
    },
    success(message){
      this.$message({
        message: message,
        type: 'success'
      });
    },
    parseUndefined(value){
      return value===undefined?'':value;
    },
    error(message){
      this.$message.error(message);
    },
    warn(message){
      this.$message({
        message: message,
        type: 'warning'
      });
    },
    removeUser(){
      sessionStorage.removeItem(config.SESSION_KEY);
    },
    async getLoginUser(){
      //得到sessionStorage里的用户数据
      var user=sessionStorage.getItem(config.SESSION_KEY);
      if(user && user.indexOf('autostringify-') === 0 ){//有取到用户数据
        return JSON.parse(user.split('autostringify-')[1]);
      }else{//没取到直接用户数据，尝试去后台取
        //请求后端得到user
        await this.doajax(userinfo,{},(resp) => {
          sessionStorage.setItem(config.SESSION_KEY,'autostringify-'+JSON.stringify(resp.info));
          user=resp.info;
        });
        return user;
      }
    },
    async refreshUser(){
      sessionStorage.removeItem(config.SESSION_KEY);
      await this.doajax(userinfo,{},(resp) => {
        sessionStorage.setItem(config.SESSION_KEY,'autostringify-'+JSON.stringify(resp.info));
        user=resp.info;
      });
      return user;
    }
  }
};




// WEBPACK FOOTER //
// ./src/data/service.js